export default __webpack_public_path__ + "img/sagoo/sagoo6.mp4";